// Paul Irish' shorthand log (converted to use apply)
export default function log() {
  log.history = log.history || [];
  log.history.push(arguments);
  if(window.console && console.log.apply) {
    console.log.apply(console, arguments)
  }
};
